// extracted by mini-css-extract-plugin
module.exports = {"McsTextAreaLabel":"McsTextArea_McsTextAreaLabel__nrKjC","McsTextAreaMaxLength":"McsTextArea_McsTextAreaMaxLength__2wp1_"};